import {
  Box,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  Typography,
} from '@mui/material';
import PropTypes from 'prop-types';
import ServiceDocUpload from '../VehiclePage/TireConfig/ServiceDocUpload';
import vergolst from 'assets/images/Vergoelst.png';
import driver from 'assets/images/Driver.png';
import { useSelector } from 'react-redux';
import { fleetOverviewSelector } from 'redux/fleets/ducks';
import { useTranslation } from 'react-i18next';

function ServiceDocUploadSelection({
  selectedFleet,
  setSelectedFleet,
  getVehiclesForFleetHandler,
  allFleetVehicles,
  selectedVehicle,
  setSelectedVehicle,
  getSpecificVehicleHandler,
  classes,
  serviceProviderHandler,
  uploadType,
  files,
  setFiles,
  step,
  setStep,
  popUpCode,
  setPopUpCode,
  upload,
  content,
  setContent,
  isLoadingData,
  setIsLoadingData,
}) {
  const fleets = useSelector(fleetOverviewSelector)?.fleets;
  const { t } = useTranslation();

  return (
    <Box
      display={'flex'}
      flexDirection={'column'}
      gap={'20px'}
      justifyContent={'center'}
    >
      <FormControl variant='outlined' fullWidth>
        <InputLabel id='demo-simple-select-outlined-label'>
          {t('singleVehicleUpload.selectFleet')}
        </InputLabel>
        <Select
          required
          name='fleet'
          labelId='demo-simple-select-outlined-label'
          id='demo-simple-select-outlined'
          value={selectedFleet}
          onChange={async e => {
            setSelectedFleet(e.target.value);
            await getVehiclesForFleetHandler(e.target.value);
          }}
          label='Select Fleet'
          variant='outlined'
          fullWidth
          data-hook='select-fleet'
        >
          {fleets.map(entry => {
            return (
              <MenuItem key={entry?.fleet_id} value={entry?.fleet_id}>
                {entry?.fleet_name}
              </MenuItem>
            );
          })}
        </Select>
      </FormControl>
      {allFleetVehicles.length > 0 && (
        <FormControl variant='outlined' fullWidth>
          <InputLabel id='demo-simple-select-outlined-label'>
            {t('uploadCenter.selectVehicle')}
          </InputLabel>
          <Select
            required
            name='vehicle'
            labelId='demo-simple-select-outlined-label'
            id='demo-simple-select-outlined'
            value={selectedVehicle?.vehicle_id}
            onChange={async e => {
              setSelectedVehicle(e.target.value);
              await getSpecificVehicleHandler(e.target.value);
            }}
            label='Select Vehicle'
            variant='outlined'
            fullWidth
            data-hook='select-vehicle'
          >
            {allFleetVehicles
              .filter(vehicle => vehicle.vehicle_type === 'TRAILER')
              .map(entry => {
                return (
                  <MenuItem key={entry?.vehicle_id} value={entry?.vehicle_id}>
                    {entry?.name}
                  </MenuItem>
                );
              })}
          </Select>
        </FormControl>
      )}
      <Box display={'flex'} flexDirection={'column'} gap={'10px'}>
        <Typography variant='h6'>
          {t('fleetOverviewPage.tireProvider')}
        </Typography>
        <Box
          display={'flex'}
          alignItems={'center'}
          gap={'20px'}
          flexWrap={'wrap'}
        >
          <Box
            borderRadius={2}
            p={2}
            className={classes.serviceProvider}
            onClick={serviceProviderHandler}
            style={{
              boxShadow:
                uploadType === 'driver' &&
                '0px 0px 10px rgba(29, 78, 216, 0.5)',
            }}
          >
            <img
              src={driver}
              alt='driver'
              style={{
                width: 150,
              }}
            />
          </Box>
          <Box
            borderRadius={2}
            p={1}
            className={classes.serviceProvider}
            onClick={serviceProviderHandler}
            style={{
              boxShadow:
                uploadType === 'vergolst' &&
                '0px 0px 10px rgba(29, 78, 216, 0.5)',
            }}
          >
            <img
              src={vergolst}
              alt='vergolst'
              style={{
                width: 150,
              }}
            />
          </Box>
        </Box>
      </Box>
      {uploadType &&
        selectedFleet &&
        Object.keys(selectedVehicle || {}).length > 0 && (
          <ServiceDocUpload
            category={uploadType}
            files={files}
            setFiles={setFiles}
            activeStep={step}
            setActiveStep={setStep}
            configData={selectedVehicle}
            popUpCode={popUpCode}
            setPopUpCode={setPopUpCode}
            uploadDocument={upload}
            content={content}
            setContent={setContent}
            loading={isLoadingData}
            setLoading={setIsLoadingData}
          />
        )}
    </Box>
  );
}

ServiceDocUploadSelection.propTypes = {
  selectedFleet: PropTypes.string.isRequired,
  setSelectedFleet: PropTypes.func.isRequired,
  getVehiclesForFleetHandler: PropTypes.func.isRequired,
  allFleetVehicles: PropTypes.array.isRequired,
  selectedVehicle: PropTypes.object.isRequired,
  setSelectedVehicle: PropTypes.func.isRequired,
  getSpecificVehicleHandler: PropTypes.func.isRequired,
  classes: PropTypes.object.isRequired,
  serviceProviderHandler: PropTypes.func.isRequired,
  uploadType: PropTypes.string.isRequired,
  files: PropTypes.array.isRequired,
  setFiles: PropTypes.func.isRequired,
  step: PropTypes.number.isRequired,
  setStep: PropTypes.func.isRequired,
  popUpCode: PropTypes.string.isRequired,
  setPopUpCode: PropTypes.func.isRequired,
  upload: PropTypes.func.isRequired,
  content: PropTypes.string.isRequired,
  setContent: PropTypes.func.isRequired,
  isLoadingData: PropTypes.bool.isRequired,
  setIsLoadingData: PropTypes.func.isRequired,
};

export default ServiceDocUploadSelection;
